<template>
    <div class="rv-create p-0">
        <div class="title p-3 border-bottom border-primary fw-600" v-if="$detect == 'web'">
            Đăng sản phẩm
        </div>
        <div :class="{
                'body': true,
                'p-3': $detect == 'web'
            }">
            <imageCreate
                :data.sync="form.data_gallery"
                :pictureMain.sync="form.picture"
                :error.sync="error.data_gallery"
                :errorPicture.sync="error.picture"/>
            <titleCreate
                :data.sync="form.name"
                :error.sync="error.name"/>
         
            <priceCreate :data.sync="form.price"/>
            <div class="d-flex">
                 <vat class="w-vat"
                    :data.sync="form.vat" :error.sync="error.vat" /> <!-- thuế -->
                <minQuantity :data.sync="form.minQuantity"/> <!-- số lượng tối thiểu -->
            </div>
            <callBuy :data.sync="form.quantity"/> <!-- hiện thị nút đặt mua hay gọi cho sản phẩm -->
            <div class="d-flex">
                <typeCreate :data.sync="form.type"/> <!-- nguồn gốc của sản phẩm -->
                <newOld :data.sync="form.quality"/>    <!-- trạng thái cũ mới của sản phẩm -->
            </div>
            <warranty :data.sync="form.warranty" :error.sync="error.warranty"/>
            <origin :data.sync="form.origin"
                    :error.sync="error.origin"/>
            <div class="mt-4 content">
                <p class="mb-2 fs-14px">Nội dung:</p>
                <editor :content.sync="form.description"/>
                <p class="mb-0 fs-14px text-note-img mt-1">* Nhập nội dung đầy đủ, đa dạng thì bài đăng sẽ xuất hiện ở nhiều công cụ tìm kiếm và người dùng dễ dàng tiếp cận hơn.</p>
                <div class="text-danger fs-12px mt-1" v-if="error.description">{{error.description}}</div>
            </div>
            <div style="height: 80px;" v-if="$detect == 'mobile'"></div>
            <div :class="{
                    'confirm mt-4 text-center': true,
                    'p-3 confirm-mobile fixed-bottom bg-white': $detect == 'mobile'
                }">
                <button type="button" class="btn btn-primary"
                    :disabled="loading" @click="submit()">Đăng bán</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
        category: () => import('@/components/profile/create/category.vue'),
        city: () => import('@/components/profile/create/city.vue'),
        editor: () => import('@/components/editor/index'),
        imageCreate: () => import('@/components/profile/create/image'),
        titleCreate: () => import('@/components/profile/create/title'),
        unit: () => import('@/components/profile/create/unit'),
        minQuantity: () => import('@/components/profile/create/minQuantity'),
        addressCreate: () => import('@/components/profile/create/address'),
        priceCreate: () => import('@/components/profile/create/price'),
        typeCreate: () => import('@/components/profile/create/source'),
        newOld: () => import('@/components/profile/create/quality'),
        warranty : () => import('@/components/profile/create/warranty'),
        website : () => import('@/components/profile/create/website'),
        vat : () => import('@/components/profile/create/vat'),
        callBuy : () => import('@/components/profile/create/callBuy'),
        origin : () => import('@/components/profile/create/origin'),

    },
    data() {
        return {
            imgPrimary: false,
            id: this.$route.params.id,
            form: {
                name: '',
                category: '',
                description: '',
                unit: '',
                city: '',
                type: 1,
                origin : '',
                minQuantity: 1,
                price: '',
                new_old: '',
                picture: '',
                data_gallery: [],
                quality : 0,
                warranty: 0,
                website : '',
                vat : 1,
                quantity : 1,
            },
            error: {},
            suggestCategory: [],
            loading: false,
        }
    },
    created() {
        this.$store.commit('dataTitle', 'Đăng sản phẩm');
        apiGet(`/v2/profile/products/create/${this.id}`).then(res => {
            let data = res.data;
            this.form.name = data.pro_name;
        }).catch(err => {
            if(err.status == 410){
                this.$message({
                    message: err.data.message,
                    type: 'error',
                    center: true,
                });
                this.$router.push({
                    name: 'product',
                    params: ''
                })
            }

        });
    },
    methods: {
        async submit(){
            if(this.loading) return;
            this.loading = true;
            this.error = {};
          
            let form = {};
            form.name = this.form.name;
            form.description = this.form.description;
            form.vat =  this.form.vat;
            form.type = this.form.type;
            form.warranty = this.form.warranty;
            form.min_quantity = this.form.minQuantity;
            form.quantity = this.form.quantity;
            form.origin = this.form.origin;
            form.price = this.$stringToNumber(this.form.price);
            form.quality = this.form.quality;
            if(this.form.picture){
                form.picture = this.form.picture;
            }else{
                if(this.form.data_gallery.length > 0){
                    form.picture = this.form.data_gallery[0].filename;
                }
            }
            form.data_gallery = [];
            this.form.data_gallery.map(item => {
                form.data_gallery.push({
                    name: item.filename,
                    width: item.width,
                    height: item.height
                });
            });
            await apiPost(`/v2/profile/products/create/${this.id}`, form).then(res => {
                if(res.success == 1){
                    this.$message({
                        message: res.message,
                        type: 'success',
                        center: true,
                    });
                    this.$router.push({
                        name: 'product-update',
                        params: {
                            id: this.id
                        }
                    })
                }else{
                    this.error =res.message.error;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            }).catch(err => {
                if(err.status == 422){
                    this.error = err.data;
                    this.$message({
                        message: 'Vui lòng kiểm tra lại các trường',
                        type: 'warning',
                        center: true,
                    });
                }
            });
            this.loading = false;
        }
    }
};
</script>
<style lang="scss">
    .box-btn-x{
        width: calc(50% - 4px);
    }
    .btn_rdo{
        display: inline-block;
        background: #ccc;
        border-radius: 3px;
        color: #fff;
        height: 50px;
        line-height: 48px;
        opacity: 1;
        text-align: center;
        /* width: calc(50% - 4px); */
        width: 110px;
        border: 1px solid #ccc;
        transition: all 0.3s;
        box-sizing: border-box;
        position: relative;
        font-weight: 700;
        margin-top: 0;
        font-size: 16px;
        &.btn_rdo_call{
            background: #33a837;
            border: 1px solid #33a837;
        }
        &.btn_rdo_buy{
            background: #f44f00;
            border: 1px solid #f44f00;
        }
    }
    .call-or-buy{
        padding: 11px 0;
        border-radius: 4px;
        border-top: 1px solid #007bff;
        // border-bottom: 1px solid #007bff;

        .buy-call{
            top: -13px;
            padding: 0 10px;
            background: #fff;
            margin-left: 10px;
            color: #007bff;
        }
    }
    .min-quantity,.unit, .quality, .type,.w-vat{
        width: calc(50% - 4px);

    }
    .min-quantity,.quality {
        margin-left: 8px;
    }
    input {
        box-shadow: none !important;
        -webkit-appearance: none !important;
    }
    .rv-create {
        .body {
            .confirm {
                button {
                    padding: 8px 60px !important;
                }
            }
            .confirm-mobile {
                box-shadow: 0 -3px 6px rgba(0,0,0,0.16), 0 -2px 4px rgba(0,0,0,0.12);
                button {
                    width: 100%;
                }
            }
        }
    }
    .rv-valiadate-input-form {
        input {
            border: 1px solid #dc3545 !important;
        }
        label {
            color: #dc3545 !important;
        }
    }
    .input-focus-effect {
        position: relative;
        display: flex;
        flex-direction: column-reverse;
        input {
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
            &:focus {
                border-color: #007bff;
            }
            &:focus + label {
                transform: translateY(0);
                top: -13px;
                color: #007bff;
                background: #fff;
                padding: 0 10px;
                font-size: 14px;
                margin-left: -5px;
            }
        }
        label {
            position: absolute;
            top: 50%;
            left: 1rem;
            transform: translateY(-50%);
            pointer-events: none;
            color: #999;
            transition: 0.15s linear;
            font-size: 16px;
        }
        .input-on-alue {
            transform: translateY(0) !important;
            top: -13px !important;
            color: #007bff !important;
            background: #fff !important;
            padding: 0 10px !important;
            font-size: 14px !important;
            margin-left: -5px !important;
        }
    }
</style>
